export default __webpack_public_path__ + "static/media/transcript.04a6d6ef.pdf";